import _TopHeader2 from "tvu-common-ui/lib/style/top-header.css";
import _TopHeader from "tvu-common-ui/lib/top-header";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import "babel-polyfill";
import i18n from '@/lang';
import '@/assets/css/index.css';
import axios from '@/assets/js/axiosExtend.js';
import VueAxios from 'vue-axios';
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(_TopHeader);
Vue.use(VueAxios, axios);
const $message = options => {
  if (options.single) {
    if (document.getElementsByClassName("el-message").length === 0) {
      return ElementUI.Message({
        ...options,
        offset: 50,
        showClose: true
      });
    }
  } else {
    return ElementUI.Message({
      ...options,
      offset: 50,
      showClose: true
    });
  }
};
["success", "warning", "info", "error"].forEach(type => {
  $message[type] = options => {
    if (typeof options === "string") {
      options = {
        message: options,
        offset: 50,
        showClose: true
      };
    }
    options.type = type;
    if (options.single) {
      if (document.getElementsByClassName("el-message").length === 0) {
        return ElementUI.Message(options);
      }
    } else {
      return ElementUI.Message(options);
    }
  };
});

// 将$message挂载到this上
Vue.prototype.$message = $message;
new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");